import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button, message } from 'antd';
import Card from '../../../../../components/Card/Card';
import Modal from '../../../../../components/Modal/Modal';
import InfoBox from '../../../../../components/InfoBox/InfoBox';
import ModuleEmptyState from '../../../../../components/ModuleEmptyState';
import PolicyMemberEdit from './PolicyMemberEdit';
import { fetchContact } from '../../Contact/ContactAction';
import { businessInfoSelector, orgIdSelector } from '../../../OrganisationSelectors';
import { getPartnerAccent } from '../../../../../themes/partnerTheme';
import { MSG_ERROR, MSG_SAVE_SUCCESS } from '../../../../../constants';
import { getApiErrorMessage } from '../../../../../utils/httpError';

const POLICY_MEMBER_GUIDANCE = (
  <>
    <strong>What to do:</strong> assign senior executives who will be responsible for this plan using{' '}
    <strong>Add new</strong> or <strong>Edit</strong>.
  </>
);

const POLICY_MEMBER_DETAIL =
  'Senior executives will be accountable for critical business functions, and are required to oversee the development, maintenance and testing of Business Continuity Plans. They are to ensure that risks are analyzed and that essential services are maintained at an acceptable level during a major disruptive event, and restored to full functionality within an acceptable timeframe. It is the social and economic accountability that the business has, to all its stakeholders, and cannot be pushed to lower levels within the organisation.';

const PolicyMember = ({
  color = getPartnerAccent('design'),
  title,
  members = [],
  businessInfo,
  orgId,
  fetchContact,
  addMember,
}) => {
  useEffect(() => {
    fetchContact(orgId);
  }, [orgId, fetchContact]);

  const onAdd = async (addedMemberContacts) => {
    try {
      await Promise.resolve(addMember(addedMemberContacts));
      message.success(MSG_SAVE_SUCCESS);
    } catch (err) {
      message.error(getApiErrorMessage(err, MSG_ERROR));
      throw err;
    }
  };

  const hasMembers = members.length > 0;
  const memberModal = (button) => (
    <Modal title="Add new member" toggle={(show) => button(show)}>
      {(hide) => <PolicyMemberEdit memberContacts={members} addMember={onAdd} close={hide} />}
    </Modal>
  );

  return (
    <Card color={color} title={title}>
      <InfoBox
        color={color}
        className="policy-member-guidance"
        guidance={POLICY_MEMBER_GUIDANCE}
        message={POLICY_MEMBER_DETAIL}
      />
      {hasMembers ? (
        <>
          <Row gutter={20} className="policy-members">
            {members.map((obj) => (
              <Col xs={12} sm={12} md={8} lg={8} xl={8} xxl={6} key={obj.contactId}>
                <div className="policy-members-item">
                  <i className="policy-icon fa fa-user" style={{ color }} />
                  <div className="policy-tile-subtitle" title={businessInfo.name}>
                    {businessInfo.name}
                  </div>
                  <div className="policy-tile-title" title={obj.jobTitle}>
                    {obj.jobTitle ? obj.jobTitle : 'No Job Title'}
                  </div>
                  <div className="policy-tile-text" style={{ color }}>{`${obj.firstName} ${obj.lastName}`}</div>
                </div>
              </Col>
            ))}
          </Row>
          <div className="btn-container">
            {memberModal((show) => (
              <Button type="primary" icon="edit" onClick={show}>
                Edit
              </Button>
            ))}
          </div>
        </>
      ) : (
        <ModuleEmptyState
          moduleTitle={title}
          embedded
          headline="No accountable members yet"
          description="Assign senior executives who will be accountable for the implementation, maintenance and testing of this Business Continuity Plan."
          iconType="user"
        >
          {memberModal((show) => (
            <Button type="primary" className="module-empty-state__btn-primary" htmlType="button" onClick={show}>
              Add First Member
            </Button>
          ))}
        </ModuleEmptyState>
      )}
    </Card>
  );
};

const mapStateToProps = (state) => ({
  businessInfo: businessInfoSelector(state),
  orgId: orgIdSelector(state),
});

const mapDispatchToProps = { fetchContact };

export default connect(mapStateToProps, mapDispatchToProps)(PolicyMember);
